/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { CoreModule } from "@html-core";
import { UtilsModule } from "../../shared/utils/utils.module";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { SharedCommonModule } from "./shared.common.module";
import { CommonModule } from "@angular/common";

@NgModule({
   imports: [CommonModule, SharedCommonModule, UtilsModule, CoreModule],
   declarations: [],
   schemas: [NO_ERRORS_SCHEMA],
   exports: [SharedCommonModule, UtilsModule, CoreModule]
})
export class ClientCommonModule {}
